import React, { Component } from "react";
import {websiteUrl} from "../../utils/common";

const DashboardMap = (props) => 
    { 
       
     const wEBURL=websiteUrl();      
     //const strUrl=wEBURL+`AVTDashboard.html?VehicleNO=${props.Routeobj.vehicleno} &Trip_ID=${props.Routeobj.Tripno}&fromDate=${props.Routeobj.FromDate}`;
     //const strUrl=wEBURL+`AVTDashboard.html?AccountID=${ props.accountid}`; 
     
     const strUrl=wEBURL+`AVTDashboard.html?AccountID=${props.objmapdata.accountid}&deviceId=${props.objmapdata.deviceId}&typeid=${props.objmapdata.typeid}`;
     //alert(strUrl);
     return ( 
     <>                     
     <iframe width="100%" height="900px" src={strUrl}  title="" ></iframe>  
     </>       
     )
}; 
   
export default DashboardMap;
